import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as STORAGE_BUCKET from '../../constants/storageBucket';

export async function getCsvUrl(fileId) {
	var getUrl = firebase.functions().httpsCallable('getCsvPublicUrl');
	var publicUrl;

	console.log('getCsvUrl_fileId', fileId);
	try {
		await getUrl({
			projectCode: PROJECT_CODE.projectCode,
			storageBucket: STORAGE_BUCKET.storageBucket,
			fileId: fileId,
		}).then((url) => {
			if (!url) {
				getCsvUrl(fileId);
			} else {
				publicUrl = url;
			}
		});

		return publicUrl.data;
	} catch (error) {
		console.error('Failed getting the url...');
		return;
	}
}
